import { ENV } from '~/common/enums/enums';
import { SeoPayload } from '~/common/types/types';

const seoPayload: SeoPayload = {
  title: 'seo.main.title',
  description: 'seo.main.description',
  siteUrl: ENV.APP.URL,
};

export { seoPayload };
